// Chapter 3 writing frames ("מסגרות"), uploaded 29.10.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch3_fN"> in src/chapters/chapter-3.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH3_FRAMES: Frame[] = [
  {
    "id": "ch3_f1",
    "n": "3.1",
    "title": "עובדה וסיפור",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "האירוע (שם קצר):",
      "מה קרה (מה שמצלמה הייתה רואה)|הסיפור שסיפרתי לעצמי"
    ]
  },
  {
    "id": "ch3_f2",
    "n": "3.2",
    "title": "מה כבה אצלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה כבה אצלי באותן דקות (סמני: אפשרויות / גמישות / חשיבה קדימה / תיאבון / הקשבה):",
      "מי היה עובר את זה ומחייך, ומה הוא היה אומר:"
    ]
  },
  {
    "id": "ch3_f3",
    "n": "3.3",
    "title": "שני סימנים על סרגל אחד",
    "type": "scale2",
    "intro": "",
    "fields": [
      "הסרגל שנפגע (יושרה / הוגנות / נדיבות / טוב-לב / כבוד / אהבה / אחר):",
      "איפה אני מצפה שהדברים יהיו",
      "איפה האירוע נחת לפי הפרשנות שלי"
    ]
  },
  {
    "id": "ch3_f4",
    "n": "3.4",
    "title": "הצל והחתול",
    "type": "twocol",
    "intro": "",
    "fields": [
      "הפחד אמר שיקרה...|מה קרה בפועל"
    ]
  },
  {
    "id": "ch3_f5",
    "n": "3.5",
    "title": "נקודת ההתפקחות שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "הסימן הראשון היה (מילה / מחשבה / תחושה בגוף):",
      "אם הייתי עוצרת בדיוק שם, הייתי:"
    ]
  },
  {
    "id": "ch3_f6",
    "n": "3.6",
    "title": "הסיפור השני",
    "type": "final",
    "intro": "",
    "fields": [
      "הסיפור השני (אותן עובדות, פרשנות של היום, שלוש שורות):",
      "",
      "",
      "מה השתנה בין הסיפור הראשון לשני:",
      "הדרך שאנסה השבוע לשתי דקות של שקט (נשימה / שעון / הליכה / אחר):"
    ]
  }
];
